import { render, staticRenderFns } from "./NQIDetail.vue?vue&type=template&id=037524c9&scoped=true"
import script from "./NQIDetail.vue?vue&type=script&lang=js"
export * from "./NQIDetail.vue?vue&type=script&lang=js"
import style0 from "./NQIDetail.vue?vue&type=style&index=0&id=037524c9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037524c9",
  null
  
)

export default component.exports